export const BACKEND_API = "http://localhost:5000/api";
export const BASE_URL = "/all-store";